import Link from "next/link";
import { useState } from "react";
import { format, parseISO } from "date-fns";

export default function NewsletterForm() {
  const [email, setEmail] = useState("");
  const [vorname, setVorname] = useState("");
  const [eventType, setEventType] = useState("");
  const [status, setStatus] = useState(null);
  const [eventDate, setEventDate] = useState(new Date());
  const today = new Date();
  const endDate = new Date(
    today.getFullYear() + 2,
    today.getMonth(),
    today.getDate()
  );

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch("/api/subscribe", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, vorname, eventType, eventDate }),
      });

      const result = await response.json();
      if (response.ok) {
        setStatus({
          type: "success",
          message:
            "Erfolgreich angemeldet. Prüfe jetzt deinen Posteingang und bestätige deine E-Mail Adresse (prüfe auch deinen Spam-Ordner).",
        });
        setEmail("");
        setVorname("");
        setEventType("");
        setEventDate(new Date());
      } else {
        setStatus({ type: "error", message: result.message });
      }
    } catch (error) {
      setStatus({ type: "error", message: "Fehler beim Senden der Anfrage." });
    }
  };

  return (
    <form onSubmit={handleSubmit} className="flex flex-col gap-5 text-[16px]">
      <div className="w-full">
        <label className="block font-bold mb-1" htmlFor="EMAIL">
          Deine E-Mail Adresse
        </label>
        <input
          type="email"
          id="EMAIL"
          name="EMAIL"
          value={email}
          className="shadow appearance-none border rounded w-full py-2 px-3 leading-tight focus:outline-none focus:shadow-outline"
          onChange={(e) => setEmail(e.target.value)}
          required
        />
      </div>

      <div className="w-full">
        <label className="block font-bold mb-1" htmlFor="VORNAME">
          Dein Vorname
        </label>
        <input
          type="text"
          id="VORNAME"
          name="VORNAME"
          value={vorname}
          className="shadow appearance-none border rounded w-full py-2 px-3 leading-tight focus:outline-none focus:shadow-outline"
          onChange={(e) => setVorname(e.target.value)}
          required
        />
      </div>

      <div className="w-full">
        <label className="block font-bold mb-1" htmlFor="EVENTTYPE">
          Für welches Event suchst du eine Fotobox?
        </label>
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-2">
          <label className="flex items-center gap-1">
            <input
              type="radio"
              name="EVENTTYPE"
              value="1"
              checked={eventType === "1"}
              onChange={(e) => setEventType(e.target.value)}
              required
            />
            <span>Hochzeit</span>
          </label>
          <label className="flex items-center gap-1">
            <input
              type="radio"
              name="EVENTTYPE"
              value="2"
              checked={eventType === "2"}
              onChange={(e) => setEventType(e.target.value)}
              required
            />
            <span>Geburtstag</span>
          </label>
          <label className="flex items-center gap-1">
            <input
              type="radio"
              name="EVENTTYPE"
              value="3"
              checked={eventType === "3"}
              onChange={(e) => setEventType(e.target.value)}
              required
            />
            <span>Abschluss / Abi</span>
          </label>
          <label className="flex items-center gap-1">
            <input
              type="radio"
              name="EVENTTYPE"
              value="4"
              checked={eventType === "4"}
              onChange={(e) => setEventType(e.target.value)}
              required
            />
            <span>Firmenevent</span>
          </label>
          <label className="flex items-center gap-1">
            <input
              type="radio"
              name="EVENTTYPE"
              value="5"
              checked={eventType === "5"}
              onChange={(e) => setEventType(e.target.value)}
              required
            />
            <span>Weihnachtsfeier</span>
          </label>
          <label className="flex items-center gap-1">
            <input
              type="radio"
              name="EVENTTYPE"
              value="6"
              checked={eventType === "6"}
              onChange={(e) => setEventType(e.target.value)}
              required
            />
            <span>Sonstige</span>
          </label>
        </div>
      </div>

      {(eventType === "1" || eventType === "2") && (
        <div className="w-full">
          <label className="block font-bold mb-1" htmlFor="EVENTDATE">
            Wann findet das Event statt?
          </label>

          <input
            type="date"
            value={format(eventDate, "yyyy-MM-dd")}
            min={format(today, "yyyy-MM-dd")}
            max={format(endDate, "yyyy-MM-dd")}
            onChange={(e) => setEventDate(new Date(e.target.value))}
            className="shadow appearance-none border rounded w-full py-2 px-3 leading-tight focus:outline-none focus:shadow-outline"
            required
          />
        </div>
      )}

      <label>
        <input type="checkbox" name="privacy" className="mr-1" required />
        Ich bestätige den{" "}
        <Link href="/datenschutz" target="_blank" className="underline">
          Datenschutz
        </Link>
        .
      </label>

      <button
        type="submit"
        className="float-right rounded-md px-8 py-2.5 font-semibold shadow-sm w-full bg-[#FF5744] text-white hover:bg-[#2C3657]"
        onClick={() => localStorage.setItem("NewsletterFilledOut", "true")}
      >
        Senden und exklusive Fotobox Gutscheine erhalten!
      </button>

      {status && (
        <p
          className={`p-2 rounded ${
            status.type === "success"
              ? "bg-green-100 text-green-800"
              : "bg-red-100 text-red-800"
          }`}
        >
          {status.message}
        </p>
      )}
    </form>
  );
}
